import React from 'react';
import {
  Box,
  Typography,
  Badge,
  useMediaQuery,
} from '@mui/material';
import { StarBorder } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { Rating } from '@mui/material';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import useServiceCard from '../../shared/logic/useServiceCard';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { theme } from '../Template';
import NoImage from 'src/assets/images/no-pictures.png';
import { extractContent } from '../../shared/logic/Utils';
import { textVariant, textClasses } from '../../shared/config';

const useRatingStyles = makeStyles(() => ({
  root:{
    fontSize:'1.5rem !important'
  },

  iconFilled:{
    color: '#0BDED6 !important',
  },

  iconHover:{
    color: '#0BDED6',
  },

  iconEmpty:{
    color: '#0BDED6 !important',
  },

  icon:{
    display:'unset !important'
  },

  card:props => ({
    boxShadow: props.shadow ? props?.shadow : '0 0 5px rgb(209, 209, 209)',
    "-webkit-box-shadow": props.shadow ? props?.shadow : '0 0 5px rgb(209, 209, 209)',
    "-moz-box-shadow": props.shadow ? props?.shadow : '0 0 5px rgb(209, 209, 209)',
    width:'100%',
    minWidth:'300px',
    backgroundColor:'#fff',

    '@media (min-width: 900px)': {
        maxWidth:'320px'
    },

    '@media (min-width: 992px)': {
      maxWidth:'400px'
    },
  })
}));

const ServiceCard = ({ service, displayDescription,productType, companyId,contentData }) => {
  const { data } = useCompanyData();
  const { t, fontFamily } = data || {};
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matches2 = useMediaQuery(theme.breakpoints.up('md'));
  const { handleClick, rating, reviews } = useServiceCard({service,productType,companyId});
  const maxStringLength = matches ? 150 : 150;
  const classes = useRatingStyles({shadow:contentData?.shadow,defaultShadow:'none'});

  const shortDescription = service?.shortDescription ? extractContent(service?.shortDescription) : '';

  const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '5px'; 
  const cardBorder = contentData?.border || 'none'; 

  const titleFontSize = contentData?.cardTitleFontSize ? contentData?.cardTitleFontSize : '24';
  const descriptionFontSize = contentData?.cardTextFontSize ? contentData?.cardTextFontSize : '16';

  const titleFontColor = contentData?.cardTitleColor ? contentData?.cardTitleColor : '';
  const descFontColor = contentData?.cardTextColor ? contentData?.cardTextColor : '';
  return (
    <Box
      display="flex"
      overflow="hidden"
      onClick={handleClick}
      height="400px"
      style={{ cursor: 'pointer' }}
      mr={matches2 ? 2 : 0}
      mb={2}
      position="relative"
      className={classes.card}
      border={cardBorder}
      borderRadius={cardRadius}
    >
      <Box width="100%" position="relative">
        <ImgLazyLoad>
          <img
            style={{ height: '100%', width: '100%', objectFit: 'fill' }}
            src={productType === 'categories' ? service.photo ? service.photo : NoImage : service?.cover}
            alt={service.name || 'service'}
          />
        </ImgLazyLoad>

      <Box
        display={{ xs: 'flex', md: 'block' }}
        position="absolute"
        bottom="3%"
        left={matches2 ? "4%" : "3%"}
        bgcolor="rgb(235 235 235 / 77%)"
        flexDirection="column"
        borderRadius="8px"
        py={3}
        px={2}
        height="42%"
        width="85%"
        justifyContent="center"
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <Typography
            variant={textVariant?.[titleFontSize]}
            className={`twoLineTxt ${textClasses?.[titleFontSize]}`}
            style={{ fontWeight: 'bold', marginRight: '1em',...(titleFontColor ? {color:titleFontColor} : {}) }}
          >
            {service.name}
          </Typography>
        </Box>

        { displayDescription ?
          <Box>
            <Typography
            variant={textVariant?.[descriptionFontSize]}
            style={{ opacity: '0.7',...(descFontColor ? {color:descFontColor} : {}) }}
            className={`twoLineTxt ${textClasses?.[descriptionFontSize]}`}
            >
              {productType === 'categories' ?
                <>
                {service && service?.description?.substring(0, maxStringLength)}
                {service && service.description ? service?.description.length > maxStringLength && '...' : ''}
                </>
                :
                <>
                {shortDescription?.substring(0, maxStringLength)}
                {shortDescription?.length > maxStringLength && '...'}
                </>
              }
            </Typography>
          </Box>
        : null }

          {productType === 'categories' ?
            null
            :
            <>
            <div style={{display:'flex',flexDirection:'row',alignItems:'center',padding:'5px 0px',position:'absolute',bottom:'16px'}}>
              <Rating
                classes={{root:classes.root,iconHover:classes.iconHover,iconFilled:classes.iconFilled,icon:classes.icon,iconEmpty:classes.iconEmpty}}
                name="half-rating-read"
                value={Number(rating)}
                precision={0.1}
                readOnly
                emptyIcon={<StarBorder />}
              />
              <span style={{margin: '0 0.5em',color: 'grey',fontFamily:'inherit'}}>{t('service.review',{count:reviews})}</span>
            </div>
            </>
          }
      </Box>
        {productType !== 'categories' && service.online && (
          <Badge style={{ position: 'absolute', top: '10px', right: '10px' }}>
            <Box bgcolor="white" px={1} borderRadius="3px">
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ fontWeight: 'bold' }}
              >
                Online
              </Typography>
            </Box>
          </Badge>
        )}
      </Box>
    </Box>
  );
};

export default ServiceCard;
